<template>
  <v-container
    fluid
    fill-height
    class="grey lighten-4"
  >
    <v-row
      justify="center"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        lg="4"
      >
        <v-card
          elevation="10"
          class="py-8"
        >
          <v-row justify="center">
            <v-col
              cols="10"
              sm="8"
              class="text-center"
            >
              <v-img
                src="/img/quats-logo.png"
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              cols="11"
              class="text-center"
            >
              <h2>{{ $t('login.new_password') }}</h2>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              cols="11"
              class="text-center"
            >
              <p style="font-size: 14px;">
                {{ $t('login.new_password_instruction_1') }}
              </p>
              <p style="font-size: 14px;">
                {{ $t('login.new_password_instruction_2') }}
              </p>
            </v-col>
          </v-row>
          <v-form
            ref="newPasswordForm"
            lazy-validation
          >
            <v-row justify="center">
              <v-col
                cols="11"
                sm="9"
              >
                <v-text-field
                  ref="input-0"
                  v-model="newPassword"
                  dense
                  :placeholder="$t('login.new_password')"
                  outlined
                  hide-details="auto"
                  type="password"
                  :rules="newPasswordRules"
                  @focus="currentIndex = 0"
                  @keydown.enter="focusNext"
                />
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col
                cols="11"
                sm="9"
              >
                <v-text-field
                  ref="input-1"
                  v-model="confirmNewPassword"
                  dense
                  :placeholder="$t('login.confirm_new_password')"
                  outlined
                  hide-details="auto"
                  type="password"
                  :rules="confirmNewPasswordRules"
                  @focus="currentIndex = 1"
                  @keydown.enter="setNewPassword"
                />
              </v-col>
            </v-row>
          </v-form>
          <v-row
            v-if="error"
            justify="center"
          >
            <v-col
              cols="11"
              sm="9"
            >
              <v-alert
                v-if="error"
                dense
                type="error"
                close-icon="mdi-close-circle-outline"
                :dismissible="true"
              >
                {{ error }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row
            v-if="success"
            justify="center"
          >
            <v-col
              cols="11"
              sm="9"
            >
              <v-alert
                v-if="success"
                dense
                type="success"
                close-icon="mdi-close-circle-outline"
                :dismissible="true"
              >
                {{ $t('login.successfully_reset') }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row
            justify="center"
            class="mt-4"
          >
            <v-col
              cols="11"
              class="text-center"
            >
              <v-btn
                :loading="loading"
                :small="$vuetify.breakpoint.xs"
                style="color: white;"
                color="primary"
                @click="setNewPassword"
              >
                {{ $t('login.set_new_password') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import QUATSError from '../plugins/error'

export default {
  data () {
    return {
      currentIndex: 0,
      loading: false,
      newPassword: null,
      confirmNewPassword: null,
      error: null,
      success: false
    }
  },
  computed: {
    newPasswordRules () {
      const pattern = /^.{6,}$/
      return [
        v => !!v || this.$t('login.new_password_required'),
        v => pattern.test(v) || this.$t('login.minimum_six')
      ]
    },
    confirmNewPasswordRules () {
      const pattern = /^.{6,}$/
      return [
        v => !!v || this.$t('login.confirm_new_password_required'),
        v => pattern.test(v) || this.$t('login.minimum_six'),
        v => v === this.newPassword || this.$t('login.password_not_match')
      ]
    }
  },
  methods: {
    setNewPassword () {
      if(this.$refs.newPasswordForm.validate()) {
        this.loading = true
        const urlParams = new URLSearchParams(window.location.search)
        const postData = { token: urlParams.get('token'), login_id: urlParams.get('signature'), password: this.newPassword, password_confirmation: this.confirmNewPassword }
        this.error = null
        return window.axios.head('/sanctum/csrf-cookie')
          .then(() => {
            return window.axios.post('/api/auth/reset-password', postData)
              .then(() => {
                this.loading = false
                this.success = true
                setTimeout(() => {
                  this.$router.push('/login')
                }, 3000)
              }).catch(err => {
                if (err.response?.status === 404) {
                  this.error = new Error(this.$t('error_message.not_found'))
                } else {
                  this.error = new Error(this.$t('error_message.something_went_wrong'))
                }
                this.loading = false
              })
          }).catch(err => {
            this.error = new QUATSError(this.$i18n, err).message
            this.loading = false
          })
      }
    },
    /**
     * @desc to move new password form fields focus to the next
     */
    focusNext() {
      this.currentIndex += 1
      const nextElement = this.$refs[`input-${this.currentIndex}`]
      if (nextElement) nextElement.focus()
    }
  }
}
</script>
